if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      // "Did the response actually contain products?" - the answer decides
      // whether the section stays or is removed from the page, so it has to
      // name EVERY card this element can be asked to hold: `.product-card` for
      // the horizontal/list cards the cart drawer renders, `.xcard` for the
      // xenon card on related-products, `.complementary-look-card` for the
      // Birlikte Al row. The class namespaces are deliberately disjoint (see
      // card-product-xenon.liquid), so a card family missing from here reads as
      // an empty response and takes its whole section down with it.
      //
      // The two `--ghost` exclusions are what keep a SKELETON from reading as a
      // loaded row. Both placeholders (product-complementary.liquid's and
      // related-products.liquid's) are built from the real card's classes so
      // they inherit its geometry, which means a bare `.xcard` test matches
      // them. Only the preloaded branch below runs that test against this
      // element's own markup, so today the distinction costs nothing — but the
      // day something sets data-preloaded, an unqualified selector would
      // declare the ghosts "loaded" and leave them on the page for good.
      static CARD_SELECTOR =
        '.product-card, .xcard:not(.xcard--ghost), .complementary-look-card:not(.complementary-look-card--ghost)';

      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        // Soft color navigation may already inject recommendation HTML so we
        // avoid a second fetch (and the empty→filled flash).
        if (this.dataset.preloaded === 'true') {
          if (this.querySelector(ProductRecommendations.CARD_SELECTOR)) {
            this.dispatchEvent(new CustomEvent('recommendations:loaded'));
          } else if (this.classList.contains('complementary-products')) {
            this.closest('.product__block')?.remove();
            this.dispatchEvent(new CustomEvent('recommendations:empty'));
          } else {
            this.closest('.shopify-section')?.remove();
            this.dispatchEvent(new CustomEvent('recommendations:empty'));
          }
          return;
        }

        if (!this.dataset.url) return;

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations?.querySelector(ProductRecommendations.CARD_SELECTOR)) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (this.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
